<template>
  <div class="home">
    <header-com></header-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">测试记录查询</h3>
        <div class="wrap">
          <el-form :inline="true" :model="formInline" size="small">
            <el-form-item style="width:120px">
              <el-input v-model="formInline.empName" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item style="width:200px">
              <el-input v-model="formInline.empIdcard" placeholder="身份证号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formInline.affiliatedEnterprise" placeholder="所属企业" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formInline.exerciseName" placeholder="测试名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="formInline.examResults" placeholder="测试结果" clearable @change="testChange">
                <el-option label="合格" value="0"></el-option>
                <el-option label="不合格" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="formInline.approvalStatus" placeholder="测试审核" clearable @change="checkChange">
                <el-option label="通过" value="0"></el-option>
                <el-option label="不通过" value="1"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item style="width: 230px">
              <el-col :span="11">
                <el-input v-model="formInline.minScore" placeholder="最低得分" clearable></el-input>
              </el-col>
              <el-col class="line" :span="2" style="text-align:center">-</el-col>
              <el-col :span="11">
                <el-input v-model="formInline.maxScore" placeholder="最高得分" clearable></el-input>
              </el-col>
            </el-form-item>-->
            <el-form-item style="width:350px">
              <el-date-picker class="picker" style="margin-right:10px" v-model="timeValue" type="daterange" :picker-options="pickerOptions"
                range-separator="至" start-placeholder="交卷时间起" end-placeholder="交卷时间止" size="small" align="right" value-format="yyyy-MM-dd"
                unlink-panels></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="onSearch">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tableData" border max-height="630" :cell-style="cellStyle" v-loading="loading" element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" highlight-current-row
            :header-cell-style="{background:'#dde9fc',color:'#606266'}">
            <!-- <el-table-column type="selection" width="50"></el-table-column> -->
            <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
            <el-table-column prop="empName" label="姓名" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="empIdcard" label="身份证号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="affiliatedEnterprise" label="所属企业" min-width="100"></el-table-column>
            <el-table-column prop="exerciseName" label="测试名称" min-width="120"></el-table-column>
            <!-- <el-table-column prop="score" label="得分" width="100"></el-table-column> -->
            <el-table-column prop="examResults" label="测试结果" :formatter="resultFormat" width="120"></el-table-column>
            <el-table-column prop="approvalStatus" label="测试审核" :formatter="checkFormat" min-width="100"></el-table-column>
            <el-table-column prop="approvalRemarks" label="测试审核意见" min-width="100"></el-table-column>
            <el-table-column prop="beginDateTime" label="开始时间" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="assignmentTime" label="交卷时间" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="primary" size="mini">查看测试照片</el-button>
                <!-- <el-button @click="aduitClick(scope.row)" type="success" size="mini">审核</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <pagination :currentPage="currentPage" :total="total" :limit="limit" ref="page" @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange" />
        </div>
      </div>
    </div>
    <!-- 查看测试照片 -->
    <el-dialog title="查看测试照片" :visible.sync="detailDialog" width="50%" @close="clearDia" center>
      <el-form ref="checkForm" :model="checkForm" label-width="120px">
        <el-form-item label="测试照片：">
          <span class="imgbox fl" v-for="(item,i) in tabList" :key="i">
            <img :src="item.imgSrc" alt />
          </span>
          <span v-if="!tabList.length">暂无照片</span>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog class="auditPop" title="审核" :visible.sync="auditDialog" @close="clearVeliaDia" width="50%" center>
      <el-form ref="form" :model="form" label-width="140px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="登记照：" class="case">
              <img :src="imgInfo.empHeadportrait" alt />
              <div v-if="!imgInfo.empHeadportrait" class="inline not">暂无登记照</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证正面照片：" class="case">
              <img :src="imgInfo.empIdcardFront" alt />
              <div v-if="!imgInfo.empIdcardFront" class="inline not">暂无身份证正面照片</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="测试照片：">
          <span class="imgbox fl" v-for="(item,i) in auditList" :key="i">
            <img :src="item.imgSrc" alt />
          </span>
          <span v-if="!auditList.length">暂无照片</span>
        </el-form-item>
        <el-form-item label="审核状态：">
          <el-radio-group v-model="form.exerciseStatus" @change="stateChange">
            <el-radio label="0">通过</el-radio>
            <el-radio label="1">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="不合格原因：">
          <el-input type="textarea" v-model="form.cateCode" :rows="3" @input="change($event)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="auditBtn">审核</el-button>
        <el-button @click="auditDialog = false" size="small" plain>取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeaderCom from "../components/Header.vue";
import http from "../api/module";
import pagination from "../components/pagination";

export default {
  name: "queryExam",
  data() {
    return {
      loading: true,
      currentPage: 1, // 当前页
      limit: 20, // 每页显示数量
      total: 0, // 总条目数
      formInline: {
        miniScore: "",
        highScore: ""
      },
      tableData: [],
      timeValue: [],
      detailDialog: false,
      tabList: [],
      auditDialog: false,
      // auditImg: [],
      auditList: [],
      checkForm: {},
      imgInfo: {},
      form: {
        exerciseStatus: "0",
        cateCode: "通过"
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  components: {
    HeaderCom,
    pagination
  },
  mounted() {
    this.getData();
  },
  methods: {
    //清空图片缓存
    clearDia(){
      this.tabList = []
    },
    clearVeliaDia(){
      this.imgInfo = {}
      this.auditList = []
    },
    // 当前页
    handleCurrentChange(val) {
      // console.log(val, "当前页");
      this.currentPage = val;
      this.getData();
    },
    // 每页数
    handleSizeChange(val) {
      this.currentPage = 1;
      this.limit = val;
      this.getData();
    },
    change(e) {
      // input 视图更新
      this.$forceUpdate();
    },
    testChange(val) {
      this.formInline.examResults = val;
    },
    checkChange(val) {
      this.formInline.approvalStatus = val;
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getData();
    },
    getData() {
      this.loading = true;
      http
        .exerciseList({
          pageNum: this.currentPage,
          pageSize: this.limit,
          empName: this.formInline.empName,
          empIdcard: this.formInline.empIdcard,
          affiliatedEnterprise: this.formInline.affiliatedEnterprise,
          exerciseName: this.formInline.exerciseName,
          entpStatus: this.formInline.examResults,
          agentStatus: this.formInline.approvalStatus,
          // minScore: this.formInline.minScore,
          // maxScore: this.formInline.maxScore,
          endDateTimeBegin: this.timeValue ? this.timeValue[0] : null, // 开始时间
          endDateTimeEnd: this.timeValue ? this.timeValue[1] : null // 交卷时间
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.tableData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 5) {
        return row.examResults == 0 ? "color:#67C23A" : "color:#F56C6C";
      } else if (columnIndex === 6) {
        return row.approvalStatus == 0
          ? "color:#67C23A"
          : row.approvalStatus == "1"
          ? "color:#F56C6C"
          : "color:#409EFF";
      } else {
        return "";
      }
    },
    resultFormat(row) {
      var examResults = row.examResults;
      return examResults == "0" ? "合格" : "不合格";
    },
    checkFormat(row) {
      var approvalStatus = row.approvalStatus;
      return approvalStatus == "0"
        ? "通过"
        : approvalStatus == "1"
        ? "不通过"
        : "待审核";
    },
    // 查看测试照片
    handleClick(row) {
      this.detailDialog = true;
      this.imgList = row.exercisePicture.split(",");
      // console.log(this.imgList, "imgList");
      this.tabList = [];
      this.imgTable = this.imgList.map(item => {
        var obj = {};
        obj.imgSrc = item;
        if (item != "") {
          this.tabList.push(obj);
        }
        return item;
      });
    },
    // 审核
    aduitClick(row) {
      console.log(row, "aduitClick");
      this.imgInfo = row;
      this.auditDialog = true;
      this.id = row.recordId;
      this.form.exerciseStatus = "0";
      this.form.cateCode = "通过";
      this.auditImg = row.exercisePicture.split(",");
      this.auditList = [];
      this.auditTable = this.auditImg.map(item => {
        var obj = {};
        obj.imgSrc = item;
        if (item != "") {
          this.auditList.push(obj);
        }
        return item;
      });
    },
    stateChange(val) {
      if (val == "0") {
        this.form.cateCode = "通过";
      } else {
        this.form.cateCode = "测试照片不合格";
      }
    },
    // 审核
    auditBtn() {
      http
        .approvalExerciseRecord({
          id: this.id,
          exerciseStatus: this.form.exerciseStatus,
          cateCode: this.form.cateCode
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message.success({
              duration: 1000,
              message: "审核通过!"
            });
            this.auditDialog = false;
            this.getData();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style lang="less" scoped>
.cont {
  margin-top: 20px;
  .wrap {
    padding: 20px;
  }
  .title {
    font-size: 18px;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
}
.scope-img {
  height: 100px;
  width: auto;
}
.auditPop /deep/.el-dialog__body {
  padding-bottom: 0;
  /deep/.el-form-item__label {
    font-size: 16px;
  }
}
// .imgs {
//   width: 100%;
//   padding: 0 100px;
//   margin-bottom: 20px;
//   display: flex;
//   justify-content: space-around;
.tag {
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
}
img {
  max-height: 140px;
  width: auto;
}
.not {
  margin-left: 10px;
  color: rgb(136, 133, 133);
}
// }

.imgbox {
  height: 100px;
  display: inline-block;
  margin-right: 10px;
  img {
    width: auto;
    height: 100%;
  }
}
</style>
